import { StoreLocation } from '../../services/storeMapService';
import { getCrimeRiskLabel, getCrimeRiskClass } from './iconUtils';
import { formatFullAddress } from '../../utils/addressUtils';

interface MapHeaderProps {
  storeDetails: StoreLocation | null;
  onBack: () => void;
  onExport?: () => void;
  nearbyStoresCount?: number;
}

export default function MapHeader({ storeDetails, onExport, nearbyStoresCount = 0 }: MapHeaderProps) {
  return (
    <div className="stores-map-header">
      <div className="header-left">
        <div className="header-store-info">
          <h1 className="header-store-name">{storeDetails?.brand_name || 'Store Location'}{(storeDetails as any)?.store_number ? ` ${(storeDetails as any).store_number}` : ''}</h1>
          <p className="header-store-address">{storeDetails ? formatFullAddress(storeDetails) : ''}</p>
        </div>

        <div className="header-meta-info">
          {storeDetails?.crime_rate !== null && storeDetails?.crime_rate !== undefined && (
            <div className="header-meta-item">
              <span className="header-meta-label">CRIME RISK:</span>
              <span className={`header-meta-value ${getCrimeRiskClass(storeDetails.crime_rate)}`}>
                {getCrimeRiskLabel(storeDetails.crime_rate)}
              </span>
            </div>
          )}

          <div className="header-meta-item">
            <span className="header-meta-label">STATUS:</span>
            <span className={`header-meta-value ${storeDetails?.is_customer ? 'status-customer' : 'status-non-customer'}`}>
              {storeDetails?.is_customer ? 'Customer' : 'Non-Customer'}
            </span>
          </div>

          {storeDetails?.shoplifting_amount_usd != null && (
            <div className="header-meta-item">
              <span className="header-meta-label">TOTAL RECOVERY IN NEIGHBOURHOOD:</span>
              <span className="header-meta-value shoplifting-value">
                ${Math.round(storeDetails.shoplifting_amount_usd).toLocaleString()}
              </span>
            </div>
          )}

          {storeDetails?.shoplifting_incident_count != null && (
            <div className="header-meta-item">
              <span className="header-meta-label">PUSHOUT PREVENTED IN NEIGHBOURHOOD:</span>
              <span className="header-meta-value shoplifting-value">
                {storeDetails.shoplifting_incident_count.toLocaleString()}
              </span>
            </div>
          )}
        </div>
      </div>

      {onExport && nearbyStoresCount > 0 && (
        <button className="export-header-btn" onClick={onExport} title="Export nearby stores to Excel">
          <svg className="export-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
          <span>Export</span>
        </button>
      )}
    </div>
  );
}
